module.exports = __webpack_public_path__ + "static/media/KamyarSamimi.0ce6905b.png";